import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import FormError from "../../components/forms/FormError";

class TaxExemptionForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>When the account is tax exempt the information that is supplied here will be shown on the invoice. <strong>If you need additional tax information such as business tax id to appear, then set that with "Set Tax Information".</strong></p>
          <FormFieldsTable>
            <Field
              label="Description"
              name="description"
              placeholder=""
              component={TextInputField}
              serverError={this.props.errors.description}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Remove Exemption" show={this.props.showRemove} onClick={this.props.onRemove} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

TaxExemptionForm.defaultProps = {
  showRemove: false
}

const ReduxForm = reduxForm({
  form: "TaxExemptionForm"
})(TaxExemptionForm);

export default ReduxForm;